import { ServiceClassAPI } from '@business/api/service_class';
import { ServiceClassId, ServiceClassResponse } from '@business/entities/project';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class ServiceClassBloc extends BaseBloc {
  private readonly classRepo = new Repository<ServiceClassResponse>({
    getItemId: item => item.id,
  });

  readonly classes$ = this.classRepo.items$;

  readonly selectClass = this.classRepo.selectItem;

  onReset() {
    this.classRepo.reset();
  }

  fetchClasses = () => {
    return ServiceClassAPI.fetchClasses().pipe(this.classRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_class_error') }));
  };

  createClass = (data: Partial<ServiceClassResponse>) => {
    return ServiceClassAPI.createClass(data).pipe(
      this.classRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('create_class'),
      }),
    );
  };

  updateClass = (id: ServiceClassId, service: Partial<ServiceClassResponse>) => {
    return ServiceClassAPI.updateClass(id, service).pipe(
      this.classRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_class'),
      }),
    );
  };

  deleteClass = (serviceId: ServiceClassId) => {
    return showDeleteConfirmation('Delete', 'Do you really want to delete this service class?').pipe(
      switchMap(() => ServiceClassAPI.deleteClass(serviceId)),
      this.classRepo.ops.removeOne(() => serviceId),
      handleMessage({
        type: requestMessage('delete_class'),
      }),
    );
  };

  updateSetting = (invoiceRequired: boolean, invoiceHide: boolean) => {
    return ServiceClassAPI.updateSetting(invoiceRequired, invoiceHide).pipe(handleMessage({ type: requestMessage('save_settings') }));
  };
}
